export default "data:image/jpeg;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNGE1MzY1MWU3MTRlZWIwZGQxZTQ0ZTI0ZWZhNThmMjUuanBnIjs="